import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { LOGIN_REQUEST } from '../constant';
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Container, StyledForm } from './StyledLogin';

const Login = ({ history, isLoading }) => {
  const dispatch = useDispatch();

  const onLogin = values => {
    dispatch({
      type: LOGIN_REQUEST,
      payload: {
        ...values,
        callback: () => {
          history.push('/posts');
        },
      },
    });
  };

  useEffect(() => {
    if (sessionStorage.getItem('token')) {
      history.push('/posts');
    }
  }, [history]);

  const renderForm = () => (
    <Form
      name="normal_login"
      className="form"
      initialValues={{ remember: true }}
      onFinish={onLogin}
    >
      <Form.Item>
        <h3 className="heading">Log in</h3>
      </Form.Item>
      <Form.Item
        name="username"
        rules={[{ required: true, message: 'Please input your Username!' }]}
      >
        <Input prefix={<UserOutlined />} placeholder="Username" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: 'Please input your Password!' }]}
      >
        <Input prefix={<LockOutlined />} type="password" placeholder="Password" />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" block loading={isLoading}>
          Log in
        </Button>
      </Form.Item>
    </Form>
  );

  return (
    <Container>
      <StyledForm>{renderForm()}</StyledForm>
    </Container>
  );
};

export default connect(state => ({
  isLoading: state.auth.isLoading,
}))(Login);
